<template>
  <div class="addRole-page">
    <div class="addRole-page-left">
      <div class="role-title">功能权限</div>
      <el-scrollbar class="scroll-bar">
        <el-tree
          style="padding-bottom: 10px"
          ref="tree"
          :data="treeData"
          :props="menusDataProps"
          show-checkbox
          @check-change="checkChange"
          :default-checked-keys="checkedNodes"
          node-key="menuCode"
        ></el-tree>
      </el-scrollbar>
    </div>
    <div class="addRole-page-right">
      <div class="role-title" style="margin: 0 0 20px">基本信息</div>
      <el-form ref="form" label-position="right" :model="form" :rules="rules">
        <el-form-item
          prop="accountGroupName"
          :label="$t('accountGroup.label.accountGroup')"
        >
          <el-input
            v-model="form.accountGroupName"
            autocomplete="off"
            :placeholder="$t('accountGroup.placeholder.accountGroup')"
            maxlength="30"
          />
        </el-form-item>
        <el-form-item
          :label="$t('accountGroup.label.remark')"
          prop="desc"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.desc"
            type="textarea"
            :rows="6"
            :placeholder="$t('accountGroup.placeholder.remark')"
            maxlength="200"
          />
        </el-form-item>
      </el-form>
      <div class="addRole-page-footer">
        <el-button
          style="margin-right: 10px"
          :loading="btnLoading"
          @click="cancelForm('form')"
          >{{ $t("accountGroup.button.cancel") }}</el-button
        >
        <el-button
          type="primary"
          @click="saveForm('form')"
          :loading="btnLoading"
        >
          {{ btnLoading ? "提交中" : $t("accountGroup.button.save") }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../api/api";
export default {
  name: "addRole",
  props: {
    treeData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showType: {
      type: String,
      default: "add",
    },
  },
  data() {
    return {
      checkedNodes: ["01"],
      formLabelWidth: "80px",
      menusDataProps: {
        children: "childrens",
        label: "menuName",
        id: "menuCode",
      },
      form: {
        accountGroupCode: "",
        accountGroupName: "",
        desc: "",
      },
      rules: {
        accountGroupName: [
          {
            required: true,
            message: this.$t("accountGroup.message.accountGroup"),
            trigger: "blur",
          },
          {
            min: 4,
            max: 30,
            message: this.$t("accountGroup.message.less30"),
            trigger: "blur",
          },
          {
            pattern: /^[0-9a-zA-Z_\u4E00-\u9FA5\uF900-\uFA2D]*$/,
            message: this.$t("accountGroup.message.formatAccount"),
            trigger: "blur",
          },
        ],
        desc: [
          {
            min: 0,
            max: 200,
            message: this.$t("accountGroup.message.less200"),
            trigger: "blur",
          },
        ],
      },
      btnLoading: false,
    };
  },
  methods: {
    cancelForm() {
      this.resetForm();
      this.$emit("cancelForm");
    },
    resetForm() {
      this.$refs.tree.setCheckedKeys(["01"]);
      this.$refs["form"].resetFields();
    },
    saveForm() {
      let url = API.addRole;
      const params = {
        accountGroupName: this.form.accountGroupName,
        codeList: this.$refs.tree.getCheckedKeys(),
        desc: this.form.desc,
      };
      if (this.showType == "edit") {
        url = API.updateRole;
        params.accountGroupCode = this.form.accountGroupCode;
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.$fetch(url, params).then((response) => {
            this.btnLoading = false;
            if (response.success) {
              this.$message({
                type: "success",
                message: this.$t("accountGroup.message.addSuccess"),
              });
              this.resetForm();
              this.$emit("submitForm");
            } else {
              this.$message({
                type: "error",
                message: response.msgContent,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    checkChange(data, isCheck, children) {
      let checkKeys = [];
      if (data.dependencyCodes && isCheck) {
        const currentkeys = this.$refs.tree.getCheckedKeys();
        checkKeys = currentkeys.concat(data.dependencyCodes.split(","));
        this.$refs.tree.setCheckedKeys(checkKeys);
      } else if (!isCheck) {
        const parentNode = this.$refs.tree.getNode(data.parentCode);
        if (parentNode && parentNode.data && parentNode.data.childrens) {
          parentNode.data.childrens.forEach((item) => {
            if (
              item.dependencyCodes &&
              item.dependencyCodes.indexOf(data.menuCode) > -1
            ) {
              this.$log.debug(item.menuCode);
              this.$refs.tree.setChecked(item.menuCode, false);
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
:deep .el-form-item__content {
  display: flex;
}
:deep .el-tree-node__content {
  height: 40px;
  line-height: 40px;
  // padding-left: 12px !important;
}
.addRole-page {
  display: flex;
  height: 100%;
  width: 100%;
  &-left {
    width: 380px;
    height: 100%;
    margin: 0px 8px 0px 0px;
    max-height: 100%;
    overflow: hidden;
    border-radius: 5px 5px 0px 0px;
    @include set_theme_color(background-color, left-menu-bg-color);
  }
  &-right {
    height: 100%;
    flex: 1;
    border-radius: 5px 5px 0px 0px;
    padding: 44px 10% 44px 54px;
    @include set_theme_color(background-color, left-menu-bg-color);
  }
  &-footer {
    padding-left: 80px;
    margin-top: 50px;
    text-align: center;
  }
  .role-title {
    margin: 10px 0 16px 10px;
    border-left: 5px solid #407aee;
    padding-left: 10px;
    font-size: 14px;
  }
  .scroll-bar {
    height: calc(100% - 50px);
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
}
</style>